import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const tableRequest = (
    venueId,
    dancerId,
    tableId,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    const params = {
        venueId: venueId,
        dancerId: dancerId,
        tableId: tableId
    };
    fetchPost(
        uri + "/user/table",
        successMethod,
        errorMethod,
        params,
        getAccessToken
    );
};